const overlapCarousel = {

	$window: $(window),
	elem: {
		$carousel: document.querySelector('#overlap-carousel')
	},
	options: {
	  pageDots: false,
	  wrapAround: false,
	  imagesLoaded: true,
	  adaptiveHeight: true,
	  friction: 0.45
	},
	flkty: '',
	carouselStatus: document.querySelector('.overlap-carousel__status'),

	init() {
		if(this.elem.$carousel) {
			overlapCarousel.flkty = new Flickity(this.elem.$carousel, overlapCarousel.options);
			overlapCarousel.updateStatus();
			overlapCarousel.flkty.on( 'select', overlapCarousel.updateStatus );
		};
	},
	updateStatus() {
		let slideNumber = overlapCarousel.flkty.selectedIndex + 1;
		overlapCarousel.carouselStatus.textContent = slideNumber + '/' + overlapCarousel.flkty.slides.length;
	},

	bindUIActions() {

	}
};

export { overlapCarousel };
